import {ApplicationStoreType} from 'desktop/store';
import {OrderDetailsType} from 'types/orderDetailsTypes';

/**
 * Returns the ordered items with type
 */
export const getSuccessPageOrderDetailsItems = (store: ApplicationStoreType) =>
    store.successPage.orderItems.orderedItems;

/**
 * Gets the order details from the store
 */
export const getOrderDetails = (store: ApplicationStoreType) =>
    store.successPage.orderLast as unknown as OrderDetailsType;

/**
 * Returns the state of the drawer
 */
export const getDrawerState = (store: ApplicationStoreType) => store.successPage.drawerPopup;
